module.exports = __webpack_public_path__ + "static/media/poster.acd70d4c.jpeg";